function updateProductSelection(scope) {
  const select = scope.querySelector('[data-variant-select]');
  if (!select) return;
  const option = select.selectedOptions[0];
  if (!option) return;
  const needsSelection = !select.value;
  const available = option.dataset.available === 'true';
  const label = !available ? scope.dataset.soldLabel : needsSelection ? scope.dataset.chooseLabel : scope.dataset.addLabel;
  scope.querySelectorAll('[data-product-price]').forEach(price => { price.textContent = option.dataset.price; });
  scope.querySelectorAll('[data-add-button], [data-sticky-add]').forEach(button => {
    button.disabled = !available;
    button.textContent = label;
  });
  if (needsSelection) return;
  scope.querySelector('[data-size-field]')?.classList.remove('size-attention');
  const prompt = scope.querySelector('[data-size-prompt]');
  if (prompt) prompt.hidden = true;
  const image = scope.querySelector('[data-main-image]');
  if (image && option.dataset.image) {
    image.src = option.dataset.image;
    image.removeAttribute('srcset');
    scope.querySelectorAll('[data-gallery-image]').forEach(button => {
      button.setAttribute('aria-pressed', String(button.dataset.galleryImage === option.dataset.image));
    });
  }
}

function chooseProductSize(scope) {
  const select = scope.querySelector('[data-variant-select]');
  if (!select || select.value) return false;
  scope.querySelector('[data-size-field]')?.classList.add('size-attention');
  const prompt = scope.querySelector('[data-size-prompt]');
  if (prompt) prompt.hidden = false;
  select.scrollIntoView({ block: 'center', behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
  select.focus({ preventScroll: true });
  return true;
}

function initializeProduct(scope) {
  if (scope.dataset.initialized) return;
  scope.dataset.initialized = 'true';
  updateProductSelection(scope);
  const bar = scope.querySelector('[data-mobile-purchase-bar]');
  const submit = scope.querySelector('[data-add-button]');
  if (!bar || !submit) return;
  const mobile = window.matchMedia('(max-width: 700px)');
  let mainVisible = false;
  const syncVisibility = () => {
    const menuOpen = Boolean(document.querySelector('.mobile-menu[open]'));
    const viewport = window.visualViewport;
    const keyboardOpen = viewport && viewport.height < window.innerHeight * 0.75 && document.activeElement?.matches('input, textarea, select');
    bar.hidden = !mobile.matches || mainVisible || menuOpen || Boolean(keyboardOpen);
  };
  document.body.classList.add('has-mobile-purchase');
  const observer = new IntersectionObserver(entries => {
    mainVisible = entries[0].isIntersecting;
    syncVisibility();
  }, { rootMargin: '0px 0px -90px 0px' });
  observer.observe(submit);
  mobile.addEventListener('change', syncVisibility);
  document.addEventListener('toggle', syncVisibility, true);
  window.visualViewport?.addEventListener('resize', syncVisibility);
  document.addEventListener('focusin', syncVisibility);
  document.addEventListener('focusout', syncVisibility);
  syncVisibility();
}

document.addEventListener('change', event => {
  const select = event.target.closest('[data-variant-select]');
  if (!select) return;
  updateProductSelection(select.closest('[data-product]'));
  const url = new URL(window.location.href);
  if (select.value) url.searchParams.set('variant', select.value);
  else url.searchParams.delete('variant');
  history.replaceState({}, '', url);
});

document.addEventListener('click', event => {
  const sizeGuideLink = event.target.closest('[data-size-guide-link]');
  if (sizeGuideLink) {
    const guide = sizeGuideLink.closest('[data-product]')?.querySelector('#ProductSizeGuide');
    if (!guide) return;
    event.preventDefault();
    const details = guide.closest('details');
    if (details) details.open = true;
    guide.setAttribute('tabindex', '-1');
    guide.scrollIntoView({ block: 'start', behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    guide.focus({ preventScroll: true });
    return;
  }
  const thumbnail = event.target.closest('[data-gallery-image]');
  if (thumbnail) {
    const scope = thumbnail.closest('[data-product]');
    const image = scope.querySelector('[data-main-image]');
    if (image) {
      image.src = thumbnail.dataset.galleryImage;
      image.removeAttribute('srcset');
      image.alt = thumbnail.dataset.alt || image.alt;
      scope.querySelectorAll('[data-gallery-image]').forEach(button => { button.setAttribute('aria-pressed', String(button === thumbnail)); });
    }
    return;
  }
  const purchaseButton = event.target.closest('[data-add-button], [data-sticky-add]');
  if (purchaseButton) {
    const scope = purchaseButton.closest('[data-product]');
    if (chooseProductSize(scope)) {
      event.preventDefault();
      return;
    }
    if (purchaseButton.hasAttribute('data-sticky-add')) {
      const submit = scope.querySelector('[data-add-button]');
      if (!submit.disabled) scope.querySelector('.product-form').requestSubmit(submit);
    }
    return;
  }
  const menu = event.target.closest('.mobile-menu a');
  if (menu) menu.closest('details').open = false;
});

document.addEventListener('keydown', event => {
  if (event.key !== 'Escape') return;
  document.querySelectorAll('.mobile-menu[open]').forEach(menu => {
    menu.open = false;
    menu.querySelector('summary').focus();
  });
});

document.querySelectorAll('[data-product]').forEach(initializeProduct);
document.addEventListener('shopify:section:load', event => {
  event.target.querySelectorAll('[data-product]').forEach(initializeProduct);
});

document.addEventListener('submit', event => {
  const form = event.target.closest('[data-store-search]');
  if (!form) return;
  const input = form.querySelector('[name="q"]');
  const terms = input?.value.trim();
  if (!terms) return;
  event.preventDefault();
  const url = new URL(form.action, window.location.origin);
  url.searchParams.set('q', `tag:othram-archive AND (${terms})`);
  url.searchParams.set('type', 'product');
  url.searchParams.set('options[unavailable_products]', 'show');
  window.location.assign(url.href);
});
